export default class RepreService {
	/* @ngInject */
	/**
	 * @param {import('~/scripts/services/model/user').UserModel} User
	 */
	constructor(User) {
		this.User = User;
	}

	/**
	 *
	 * @param {import('~/scripts/services/model/repre').default[]} repreData
	 * @returns {{lang}|*} result
	 */
	getRepre(repreData) {
		let r;

		if (repreData && Array.isArray(repreData)) {
			// Set repre as universel
			for (const repre of repreData) {
				if (repre.lang && repre.lang.kid === 'K_NODE;UNIVERSEL') {
					r = repre;
				}
			}

			// if not found
			// set repre as user language
			if (!r) {
				for (const repre of repreData) {
					if (repre.lang && repre.lang.isa === 'K_NODE;LANGUE' && (repre.lang.kid === this.User.getContext().lang[0])) {
						r = repre;
					}
				}
			}

			// if not found
			// set language to first found
			if (!r) {
				for (const repre of repreData) {
					if (repre.lang && repre.lang.isa === 'K_NODE;LANGUE') {
						r = repre;
					}
				}
			}

			// last chance!
			// pick the first one if nothing is defined
			if (!r) {
				for (const repre of repreData) {
					if (!r) {
						r = repre;
					}
				}
			}
		}
		else {
			console.error('bad data', repreData);
		}

		return r;
	}
}
